// src/App.js
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./app/routes";
import { BreadcrumbProvider } from "./contexts/BreadcrumbContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { PdfGenerationOverlay } from "./contexts/PdfGenerationOverlay";
import { PdfGenerationProvider } from "./contexts/PdfGenerationContext";
import { ToastProvider } from "./contexts/ToastContext";
import './styles/globals.css'

function App() {
  return (
    <BreadcrumbProvider>
      <NotificationProvider>
        <PdfGenerationProvider>
          <ToastProvider>
            <Router>
              <AppRoutes />
              <PdfGenerationOverlay />
            </Router>
          </ToastProvider>
        </PdfGenerationProvider>
      </NotificationProvider>
    </BreadcrumbProvider>
  );
}

export default App;
